export default () => ({
  inject: {
    glAbilities: {
      from: 'glAbilities',
      default: () => ({}),
    },
  },
});
